import { BaseEntity } from './base-entity';

export class OrgJedView extends BaseEntity{
    constructor(){
        super();
    }

    Naziv: string = null;
    ParentOrgJed: OrgJedView = null;
    CompanyID: number = null;
    FirmaNaziv: string = null;
    
    Deserialize(input: any){
        this.ID = input.ID;
        this.Naziv = input.Naziv;
        this.CompanyID = input.CompanyID;
        this.FirmaNaziv = input.FirmaNaziv;

        return this;
    }

    Serialize(input: OrgJedView){
        return input;
    }
}